import './index.css';

const CustomerOrders = () => {
  return (
    <section className="customer-orders-page">
      <div className="customer-orders-header">
        <p>Member orders</p>
        <h1>Your Hogcloud orders.</h1>
        <span>Review purchases, order status, and fulfillment details from one place.</span>
      </div>

      <div className="customer-orders-toolbar" aria-label="Order tools">
        <div>
          <strong>Orders</strong>
          <span>Purchase history will appear here.</span>
        </div>
        <button type="button">Refresh</button>
      </div>

      <div className="customer-orders-list" aria-label="Customer order list">
        <article className="customer-order-card">
          <div className="customer-order-main">
            <div>
              <span className="customer-order-kicker">Order</span>
              <h2>No orders loaded yet</h2>
            </div>
            <span className="customer-order-status">Pending setup</span>
          </div>
          <div className="customer-order-meta">
            <span>
              <strong>Date</strong>
              <em>-</em>
            </span>
            <span>
              <strong>Total</strong>
              <em>-</em>
            </span>
            <span>
              <strong>Items</strong>
              <em>-</em>
            </span>
          </div>
        </article>

        <div className="customer-orders-empty">
          <h2>Order history is coming soon.</h2>
          <p>
            This page is ready for member order data. Once the order API is connected,
            purchases will show here automatically.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CustomerOrders;
